module.exports = __webpack_public_path__ + "img/IMG-20201222-WA0025.64e1691c.jpg";